const state = {
  allResourceNum: [],
}

const mutations = {
  commonMutations: (state, payload) => {
    Object.keys(payload).forEach(item => {
      state[item] = payload[item]
    })
  },
}

const actions = {

}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
